import Vue from 'vue'
import http from '../util/axios'
import headers from '../util/headers'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)
import store from "../store";
import router from "../router";

export default {
    SET_LAYOUT({ commit }, routeName) {
        let layoutValue = 'default-layout';
        if (routeName == 'Signup') {
            layoutValue = 'login-layout'
        }
        commit('SET_LAYOUT', layoutValue);
    },
    SET_AVTAR({ commit }, uobj) {
        commit('SET_AVTAR', uobj);
    },
    SET_USER({ commit }, uobj) {
        commit('SET_USER', uobj);
    },
    SET_NOTIFICATION_COUNT({ commit }, count) {
        commit('SET_NOTIFICATION_COUNT', count);
    },
    SET_NOTIFICATIONS({ commit }, arr) {
        commit('SET_NOTIFICATIONS', arr);
    },
    async httpPost({ commit }, opts) {
        try {
            const options = {
                method: 'POST',
                data: opts.body,
                url: opts.uri,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization':  Vue.localStorage.get('token') || null,
                  'platform': "mac"
                }
            }
            let response = await http(options);
            if (response && response.data) {
                if (response.data.status == '2001') {
                    store.dispatch("SET_ALERTMESSAGE", {
                        msg: "Session Expired. Please login again",
                        class: "sa-a-danger",
                    });
                    Vue.localStorage.remove("token");
                    Vue.localStorage.remove("refresh_token");
                    Vue.localStorage.remove("userdata");
                    router.push({ path: "/" });
                    return null;
                }
                return response.data;
            } else {
                return null;
            }
        } catch (e) { 
            return null;
        }
    },
    async httpGet({ commit }, opts) {
        let token = Vue.localStorage.get('token') || null
        if (opts.token) {
            token = opts.token
        }
        try {
            const options = {
                method: 'GET',
                url: opts.uri,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
                params: { uid : opts.query }
            }
            let response = await http(options)
            if (response && response.data){
                return response.data;
            } else {
                return null;
            }
        } catch (e) {
          //  console.log("error in calling http post call", e);
        }
    },
    SET_ALERTMESSAGE({ commit }, message, persistent) {
        commit('setAlertMessage', message, persistent)
    },
    SET_FCMTTOKEN({ commit }, message) {
        commit('setFCMToken', message)
    },
    SET_NAVIGATE({ commit }, message) {
        commit('setNavigate', message)
    },
    SET_RINGING({ commit }, payload) {
        commit('SET_RINGING', payload);
    },
    SET_CALL_STATUS({ commit }, payload ) {
        commit('SET_CALL_STATUS', payload);
    },
    SET_SOCKET({ commit }, payload ) {
        commit('SET_SOCKET', payload);
    },
    SET_VIDEOCALL_PAYLOAD({ commit }, payload) {
        commit('SET_VIDEOCALL_PAYLOAD', payload);
    },
    SET_VIDEO_LAYOUT({commit}){
        commit('SET_VIDEO_LAYOUT')
    }
}
